<script setup>
import page from '@/preload/data/privacyPolicyPage.json'
import config from '@/preload/data/config.json'

useHead({
  title: `${config.pagetitle} | Datenschutz`
})
</script>

<template>
  <div v-if="page" :class="page.withoutVerticalSpace ? '' : 'mt-10'">
    <cms-block-renderer :blocks="page.blocks" />
  </div>
</template>
